/* Login popup (shopify-account) tweaks — scoped to the login component only, does not affect the page. */
/*  1. Remove the subdued grey box behind the close (X) button.                                    */
/*  2. Make the email input background match the popup card (#F5F7F9).                              */
/*  3. Set the email field text/label to 14px to match the store body font.                        */
(function () {
  var LIGHT = '#F5F7F9';
  var FONT_CSS = '.login-form__email-input,.login-form__email-label{font-size:14px;}';

  function injectFont(sr) {
    if (!sr || sr.__loginFontInjected) return;
    try {
      var s = new CSSStyleSheet();
      s.replaceSync(FONT_CSS);
      sr.adoptedStyleSheets = [].concat(sr.adoptedStyleSheets || [], s);
      sr.__loginFontInjected = true;
    } catch (e) {
      if (sr.querySelector && !sr.querySelector('style[data-login-font]')) {
        var st = document.createElement('style');
        st.setAttribute('data-login-font', '');
        st.textContent = FONT_CSS;
        sr.appendChild(st);
        sr.__loginFontInjected = true;
      }
    }
  }

  function applyTo(el) {
    if (!el || !el.tagName) return;
    if (el.tagName === 'SHOPIFY-ACCOUNT') {
      el.style.setProperty('--shopify-account-color-background-subdued', 'transparent');
    }
    if (el.tagName === 'SHOPIFY-LOGIN-FORM') {
      el.style.setProperty('--shopify-login-form-color-control-background', LIGHT);
      if (el.shadowRoot) injectFont(el.shadowRoot);
    }
  }

  function walk(root) {
    if (!root || !root.querySelectorAll) return;
    var all = root.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      applyTo(all[i]);
      if (all[i].shadowRoot) walk(all[i].shadowRoot);
    }
  }

  function fix() {
    document.querySelectorAll('shopify-account').forEach(function (acc) {
      applyTo(acc);
      if (acc.shadowRoot) {
        walk(acc.shadowRoot);
        if (!acc.__loginFixObserver) {
          acc.__loginFixObserver = new MutationObserver(function () { walk(acc.shadowRoot); });
          acc.__loginFixObserver.observe(acc.shadowRoot, { childList: true, subtree: true });
        }
      }
    });
  }

  fix();
  document.addEventListener('DOMContentLoaded', fix);
  window.addEventListener('load', fix);
  var tries = 0;
  var iv = setInterval(function () { fix(); if (++tries > 20) clearInterval(iv); }, 300);
})();
